import machineTranslationExperiments from 'bundles/epic/clients/machineTranslation';

export const enableAiDubbingExperimentForUserAndCourse = (courseId: string) => {
  return machineTranslationExperiments.get('enableAiDubbing', { course_id: courseId }) ?? false;
};

export const enableAiDubbingInternallyRollout = () => {
  return machineTranslationExperiments.get('enableAiDubbingInternally') ?? false;
};

export const isAiDubbingExperimentEnabledForUserAndCourse = (courseId: string) => {
  return machineTranslationExperiments.preview('enableAiDubbing', { course_id: courseId }) ?? false;
};

export const isAiDubbingInternallyRolloutEnabled = () => {
  return machineTranslationExperiments.preview('enableAiDubbingInternally') ?? false;
};

export const enableAiDubbing = (courseId: string) =>
  enableAiDubbingInternallyRollout() || enableAiDubbingExperimentForUserAndCourse(courseId);

export const isAiDubbingEnabled = (courseId: string) =>
  isAiDubbingInternallyRolloutEnabled() || isAiDubbingExperimentEnabledForUserAndCourse(courseId);
